import * as React from 'react'
import { Container, Grid2, TextField, Button, Box, Typography } from '@mui/material'
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import { PDFViewer } from '@react-pdf/renderer';

import dayjs from 'dayjs'
import Navbar from '../setup/Navbar'
import HeadingText from '../../BuiltInComponent/HeadingTest'
import AutoComplete from '../../BuiltInComponent/AutoComplete'
import StickyHeadTable from '../../BuiltInComponent/TableWithPagination';
import { getItemList } from '../../features/setup/useableSlice'
import { getItemDetails } from '../../features/StockManagement/itemsInformationSlice'
import { getFindOpeningByUserID } from '../../features/AdminManagement/dailyClosingSlice'
import { getInvoiceByUser, addNewItem, deleteItem, masterSave } from '../../features/StockManagement/counterSalesSlice'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export default function CounterSale() {

    const borderColor = 'white'
    const stylesTH = StyleSheet.create({
        container: {
            flexDirection: 'row',
            borderBottomColor: 'white',
            backgroundColor: 'grey',
            borderBottomWidth: 1,
            alignItems: 'center',
            height: 15,
            textAlign: 'center',
            flexGrow: 1,
            fontSize: '6px',
        },
        thsno: {
            width: '8%',
            borderRightColor: borderColor,
            borderRightWidth: 1,
        },
        thcitemname: {
            width: '48%',
            borderRightColor: borderColor,
            borderRightWidth: 1,
        },
        thquantity: {
            width: '10%',
            borderRightColor: borderColor,
            borderRightWidth: 1,
        },
        thitemunit: {
            width: '10%',
            borderRightColor: borderColor,
            borderRightWidth: 1,
        },
        thitemrate: {
            width: '10%',
            borderRightColor: borderColor,
            borderRightWidth: 1,
        },
        thitemamount: {
            width: '12%',
        },
    });

    // Table Row
    const borderColorRow = 'black'
    const stylesTR = StyleSheet.create({
        row: {
            flexDirection: 'row',
            borderBottomColor: 'black',
            borderBottomWidth: 1,
            alignItems: 'center',
            height: 'auto',
            textAlign: 'center',
            flexGrow: 1,
            fontSize: 6
        },
        trsno: {
            width: '8%',
            height: '100%',
            textAlign: 'center',
            // borderRightColor: borderColorRow,
            // borderRightWidth: 1,
            paddingLeft: 4,
        },
        tritemname: {
            width: '48%',
            height: '100%',
            textAlign: 'left',
            // borderRightColor: borderColorRow,
            // borderRightWidth: 1,
            paddingLeft: 8,
        },
        trquantity: {
            width: '10%',
            height: '100%',
            // borderRightColor: borderColorRow,
            // borderRightWidth: 1,
            textAlign: 'right',
            paddingRight: 8,
        },
        tritemunit: {
            width: '10%',
            height: '100%',
            // borderRightColor: borderColorRow,
            // borderRightWidth: 1,
            textAlign: 'right',
            paddingRight: 8,
        },
        tritemrate: {
            width: '10%',
            height: '100%',
            // borderRightColor: borderColorRow,
            // borderRightWidth: 1,
            textAlign: 'right',
            paddingRight: 8,
        },
        tritemamount: {
            width: '12%',
            height: '100%',
            textAlign: 'right',
            // paddingRight: 8,
        },
    });

    // Table Total Row
    const stylesTTR = StyleSheet.create({
        row: {
            flexDirection: 'row',
            flexWrap: 'wrap',
            backgroundColor: 'black',
            borderBottomColor: 'black',
            borderBottomWidth: 1,
            height: 10,
            textAlign: 'center',
            flexGrow: 1,
        },
        ttrtc: {
            width: '56%',
            textAlign: 'center',
            color: 'white',
            borderRightColor: borderColorRow,
            borderRightWidth: 1,
            fontSize: 6,
            paddingTop: 2,
            fontWeight: 'bold'
        },
        ttrtq: {
            width: '10%',
            textAlign: 'right',
            color: 'white',
            borderRightColor: borderColorRow,
            borderRightWidth: 1,
            paddingLeft: 8,
            fontSize: 6,
            paddingTop: 2,
            fontWeight: 'bold'

        },
        ttrspace: {
            width: '5%',
            textAlign: 'right',
            color: 'white',
            borderRightColor: borderColorRow,
            borderRightWidth: 1,
            paddingLeft: 8,
        },
        ttrta: {
            width: '27%',
            color: 'white',
            borderRightColor: borderColorRow,
            borderRightWidth: 1,
            textAlign: 'right',
            // paddingRight: 8,
            fontSize: 6,
            paddingTop: 2,
            fontWeight: 'bold'

        },
    });

    //   Table Container 
    const stylesTC = StyleSheet.create({
        tableContainer: {
            flexDirection: 'row',
            flexWrap: 'wrap',
            marginTop: 10,
            marginLeft: 10,
            marginRight: 10,
            borderWidth: 1,
            borderColor: 'black',
            fontSize: '7px',
        },
    });


    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { user } = useSelector(state => state.auth)
    const { items } = useSelector(state => state.ru)
    const { singleItem } = useSelector(state => state.itemsInf)
    const { salesMaster } = useSelector(state => state.cs)
    const { closing } = useSelector(state => state.clsng)

    React.useEffect(() => {
        dispatch(getItemList('sale'))
    }, [dispatch])

    React.useEffect(() => {
        // Fetch data if closing is empty
        if (closing.length === 0) {
            dispatch(getFindOpeningByUserID({ userID: user.userID }));
        }

        // Only update state if data is available and correct
        if (closing && closing.length > 0 && closing[0].msg === 'Not Found') {
            navigate('/DailyOpening');
        } else if (closing && closing.length > 0) {
            // Check if closing data is available before setting state
            setInvData((prevData) => ({
                ...prevData,
                entDate: dayjs(closing[0].closingDate).format('YYYY-MM-DD'),
            }));
        }
    }, [dispatch, user, navigate, closing]);

    React.useEffect(() => {
        if (salesMaster.length === 0) {
            dispatch(getInvoiceByUser({ userID: user.userID }))
                .then((res) => {
                    if (res.payload[0].msg === 'Not Found') {
                        setInvData((prevData) => ({
                            ...prevData,
                            invoiceNo: null
                        }));
                    }
                })
        } else {
            if (salesMaster[0].msg !== 'Not Found') {
                console.log('Data Found')
                setInvData((prevData) => ({
                    ...prevData,
                    invoiceNo: salesMaster[0].invoiceNo
                }));
            } else {
                console.log('Data Not Found')
                setInvData((prevData) => ({
                    ...prevData,
                    invoiceNo: null
                }));
            }
        }
    }, [dispatch, user, salesMaster])

    const [invData, setInvData] = React.useState({
        entDate: closing.length > 0 ? dayjs(closing[0].closingDate) : dayjs(new Date()).format('DD-MMM-YYYY'), custName: '1',
        invoiceNo: null, barCode: '', itemRate: 0, itemQuantity: 0
    })
    const [barCodeStatus, setBarCodeStatus] = React.useState('none')

    const onChangeItem = (data) => {
        const keys = Object.keys(data)
        if (keys[0] === 'itemCode') {
            setInvData((prevData) => ({
                ...prevData,
                barCode: data[keys]
            }));
            dispatch(getItemDetails({ itemCode: data[keys] }))
                .then(async (resultAction) => {
                    console.log('reach')

                    const item = resultAction.payload
                    if (item && item.salesPrice) {
                        console.log('Item details found, updating itemRate');

                        // Update itemRate in the state
                        setInvData((prevData) => ({
                            ...prevData,
                            itemRate: item.salesPrice
                        }));
                    }
                });
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInvData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };
    const onSubmit = () => {
        invData.userID = user.userID
        console.log(invData)
        dispatch(addNewItem(invData))
            .then(() => {
                dispatch(getInvoiceByUser({ userID: user.userID }))
            })
    }

    const masterSaveClick = () => {
        dispatch(masterSave({ invoiceNo: invData.invoiceNo, userID: user.userID }))
            .then(() => {
                dispatch(getInvoiceByUser({ userID: user.userID }))
            })
    }
    const tableColumns = [
        { fieldName: 'RONO', cName: 'Item Code', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'itemDesc', cName: 'Item Name', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'itemRate', cName: 'Sales Price', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'itemQuantity', cName: 'Quantity', textAlign: 'left', width: 80, status: 'en', dType: 'number' },
        { fieldName: 'amount', cName: 'Amount', textAlign: 'right', width: 80, status: 'en', dType: 'number' },
        { fieldName: 'Edit', cName: 'Edit', textAlign: 'right', width: 80, status: 'di', dType: 'string' },
        { fieldName: 'Delete', cName: 'Delete', textAlign: 'right', width: 80, status: 'en', dType: 'string' },
    ]

    const onDeleteClick = (RONO) => {
        dispatch(deleteItem({ RONO: RONO }))
            .then(() => {
                dispatch(getInvoiceByUser({ userID: user.userID }))
            })
    }
    return (
        <>
            <Navbar />
            <Container>
                <Typography
                    sx={{
                        width: 'fit-content', textAlign: 'right', fontWeight: 'bolder', fontSize: 18,
                        backgroundColor: '#1D4988', marginLeft: 'auto', padding: 1, borderRadius: 3,
                        color: 'white'
                    }}>Till : {closing && closing.length > 0 && closing[0].tillName}</Typography>
                <Box sx={{ p: 2 }}>
                    <HeadingText text='Counter Sale' />
                </Box>
                <Grid2 container spacing={2}>
                    <Grid2 size={2.4}>
                        {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                defaultValue={closing.length > 0 ? dayjs(closing[0].closingDate) : dayjs(new Date())}
                                format='DD-MMM-YYYY'
                                // views={['day', 'month', 'year']}
                                slotProps={{ textField: { size: 'small' } }}
                            />
                        </LocalizationProvider> */}
                        <Typography
                            sx={{ mt: 0.5, fontWeight: 'bold', backgroundColor: 'yellow', p: 0.5, borderRadius: 2, color: 'red' }}
                        >
                            Working Date : {closing && closing.length > 0 && dayjs(closing[0].closingDate).format('DD-MMM-YYYY')}</Typography>
                    </Grid2>
                    <Grid2 size={2.4}>
                        <TextField
                            name='invoiceNo'
                            fullWidth
                            id='invoiceNo'
                            label='Invoice No'
                            value={salesMaster && salesMaster.length > 0 ? salesMaster[0].invoiceNo : ''}
                            size='small'
                            disabled
                        />
                    </Grid2>
                    <Grid2 size={2.4}>
                        <TextField
                            name='custName'
                            fullWidth
                            id='custName'
                            label='Customer'
                            value={salesMaster && salesMaster.length > 0 && salesMaster[0].custName}
                            size='small'
                            disabled
                        />
                    </Grid2>
                    <Grid2 size={2.4}>
                        <TextField
                            name='noi'
                            fullWidth
                            id='noi'
                            label='No of Items'
                            value={salesMaster && salesMaster.length > 0 && salesMaster[0].NOI}
                            size='small'
                            disabled
                        />
                    </Grid2>
                    <Grid2 size={2.4}>
                        <TextField
                            name='totalAmount'
                            fullWidth
                            id='totalAmount'
                            label='Total Amount'
                            value={salesMaster && salesMaster.length > 0 && salesMaster[0].totalAmount}
                            size='small'
                            disabled
                        />
                    </Grid2>
                </Grid2>
                <Grid2 container spacing={2} sx={{ mt: 5 }}>
                    <Grid2 size={3}>
                        <TextField
                            name='barCode'
                            required
                            fullWidth
                            id='barCode'
                            label='Bar Code'
                            size='small'
                            onChange={(e) => {
                                if (e.target.value !== '') {
                                    dispatch(getItemDetails({ itemCode: e.target.value }))
                                        .then(() => {
                                            // Check if singleItem is defined and has a salesPrice
                                            if (singleItem && singleItem.salesPrice) {
                                                setInvData((prevData) => ({
                                                    ...prevData,
                                                    itemRate: singleItem.salesPrice
                                                }));
                                            }
                                        });
                                    setBarCodeStatus('none');
                                }

                                setInvData((prevData) => ({
                                    ...prevData,
                                    barCode: e.target.value
                                }));
                            }}

                            onBlur={(e) => {
                                if (invData.barCode === '') {
                                    setBarCodeStatus('display')
                                }
                                setInvData((prevData) => ({
                                    ...prevData,
                                    itemRate: singleItem.salesPrice
                                }));
                            }}
                        />
                    </Grid2>
                    <Grid2 size={3} sx={{ display: `${barCodeStatus}` }}>
                        <AutoComplete
                            listData={items && items}
                            onChange={onChangeItem}
                        />
                    </Grid2>
                    <Grid2 size={3} sx={{ display: `${barCodeStatus === 'none' ? '' : 'none'}` }}>
                        <TextField
                            name='itemDesc'
                            required
                            fullWidth
                            id='itemDesc'
                            // label='Sales Price'
                            size='small'
                            // onChange={handleChange}
                            value={singleItem && singleItem.itemDesc}
                            disabled
                        />
                    </Grid2>

                    <Grid2 size={2.25}>
                        <TextField
                            name='itemRate'
                            required
                            fullWidth
                            id='itemRate'
                            // label='Sales Price'
                            size='small'
                            onChange={handleChange}
                            value={singleItem && singleItem.salesPrice}
                            disabled
                        />
                    </Grid2>
                    <Grid2 size={2.25}>
                        <TextField
                            name='itemQuantity'
                            required
                            fullWidth
                            id='itemQuantity'
                            label='Quantity'
                            size='small'
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={1.5}>
                        <Button variant="contained" fullWidth
                            onClick={onSubmit}
                        >ADD</Button>
                    </Grid2>
                    <Grid2 size={9}></Grid2>
                    <Grid2 size={3}>
                        <Button variant="contained" fullWidth
                            onClick={masterSaveClick}
                        >SAVE INVOICE</Button>
                    </Grid2>
                    <Grid2 size={8}>
                        <StickyHeadTable
                            tableColumns={tableColumns}
                            tableData={salesMaster && salesMaster.length > 0 && salesMaster[0].msg !== 'Not Found' && salesMaster}
                            perPage={50} onDeleteClick={onDeleteClick} />

                    </Grid2>
                    <Grid2 size={4}>
                        <PDFViewer height={400} width={'100%'}>
                            <Document>
                                <Page size={{
                                    width: 2.8 * 72, height: ((3.5 + (salesMaster.length < 10 ?
                                        salesMaster.length * 0.18 :
                                        salesMaster.length > 10 ?
                                            salesMaster.length * 0.125 :
                                            salesMaster.length > 20 ?
                                                salesMaster.length * 0.115 :
                                                salesMaster.length * 0.115)) * 72)
                                }}>
                                    <View>
                                        {/* <Image style={{ height: '80px', width: '80px', alignSelf: 'center' }} src={user.cmpImage} /> */}
                                        <View style={{ marginLeft: '10px' }}>
                                            <Text style={{ fontSize: '15px', textAlign: 'center' }}>{user.cmpName}</Text>
                                            <Text style={{ fontSize: '9px' }}>{user.cmpAddress}</Text>
                                            <Text style={{ fontSize: '9px' }}>---</Text>
                                        </View>
                                    </View>
                                    <View>
                                        <Text style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'center' }}>Sales Invoice</Text>
                                    </View>
                                    <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginLeft: '5px', marginRight: '5px', marginTop: 5 }}>
                                        <Text style={{ fontSize: '8px', fontWeight: 'bold', textAlign: 'left' }}>EntDate : {dayjs(salesMaster && salesMaster.length > 0 && salesMaster[0].entDate).format('DD-MMM-YYYY')}</Text>
                                        <Text style={{ fontSize: '8px', fontWeight: 'bold', textAlign: 'left' }}>Invoice No : {salesMaster && salesMaster.length > 0 && salesMaster[0].invoiceNo}</Text>
                                    </View>
                                    <View>
                                        <Text style={{ marginLeft: '5px', fontSize: '8px', textAlign: 'left' }}>ID : {user.userID}</Text>
                                        <Text style={{ marginLeft: '5px', fontSize: '10px', textAlign: 'left' }}>Customer Name : {salesMaster && salesMaster.length > 0 && salesMaster[0].custName}</Text>
                                    </View>
                                    <View style={stylesTC.tableContainer}>
                                        <View style={stylesTH.container}>
                                            <Text style={stylesTH.thsno}>No</Text>
                                            <Text style={stylesTH.thcitemname}>Item Name</Text>
                                            <Text style={stylesTH.thquantity}>Qnty</Text>
                                            <Text style={stylesTH.thitemrate}>Rate</Text>
                                            <Text style={stylesTH.thitemamount}>Amount</Text>
                                        </View>
                                        {salesMaster && salesMaster.length > 0 && salesMaster[0].msg !== 'Not Found' && salesMaster.map((item, index) => (
                                            <View style={stylesTR.row} key={Math.random.toString()}>
                                                <Text style={stylesTR.trsno}>{index + 1}</Text>
                                                <Text style={stylesTR.tritemname}>{item.itemDesc}</Text>
                                                <Text style={stylesTR.trquantity}>{Math.round(item.itemQuantity).toLocaleString("en-US")}</Text>
                                                <Text style={stylesTR.tritemrate}>{Math.round(item.itemRate).toLocaleString("en-US")}</Text>
                                                <Text style={stylesTR.tritemamount}>{Math.round(item.itemRate * item.itemQuantity).toLocaleString("en-US")}</Text>
                                            </View>))}
                                        <View style={[stylesTTR.row, { height: 15 }]}>
                                            <Text style={[stylesTTR.ttrtc, { fontSize: 10 }]}>TOTAL</Text>
                                            <Text style={[stylesTTR.ttrtq, { fontSize: 10 }]}>{salesMaster && salesMaster.length > 0 && salesMaster[0].msg !== 'Not Found' ? Math.round(salesMaster.reduce((sum, item) => sum + item.itemQuantity, 0)).toLocaleString("en-US") : '0'}</Text>
                                            <Text style={[stylesTTR.ttrspace, { fontSize: 10 }]}></Text>
                                            <Text style={[stylesTTR.ttrta, { fontSize: 10 }]}>{salesMaster && salesMaster.length > 0 && salesMaster[0].msg !== 'Not Found' ? Math.round(salesMaster.reduce((sum, item) => sum + (item.itemQuantity * item.itemRate), 0)).toLocaleString("en-US") : '0'}</Text>
                                        </View>
                                    </View>
                                    <View>
                                        <View style={{ marginLeft: '10px', marginTop: 5 }}>
                                            <Text style={{ fontSize: '8px', fontWeight: 'bold' }}>Developed By : World Home Development</Text>
                                            <Text style={{ fontSize: '7px' }}>web. whdevs.com | Cont. 0335-2220730</Text>
                                        </View>
                                    </View>
                                </Page>
                            </Document>
                        </PDFViewer>
                    </Grid2>
                </Grid2>
                {/* <Box sx={{ mt: 5 }}>
                </Box> */}
            </Container>
        </>
    )
}
